import SubObjectCache from './SubObjectCache';

/**
 * @typedef {Object} cacheSubObject
 * @property {String} rootKey
 * @property {String} key
 */

export const rootKey = 'ATC_USER';
export const key = 'textAlerts';
export const persist = false; // Session Storage

/**
 * Handles storing and caching quick save disable notification info selected by the user
 * @module QuickSaveNotificationCache
 */
const TextAlertsSessionCache = /* #__PURE__*/(() => new SubObjectCache({
  rootKey,
  key,
  persist
}))();
export default TextAlertsSessionCache;